<template>
  <div>
    <div class="catchup-card-row keep-watching-row w-100 h-auto">
      <!-- CATCHUP TITLE ROW -->
      <div class="row catchup-title-row">
        <div
          class="col-12 d-flex justify-content-between align-items-center nowrap"
        >
          <!-- LEFT -->
          <div class="left">
            <div class="title brand_white font-weight-bold">Keep Watching</div>
          </div>

          <!-- RIGHT-->
          <div class="right" v-if="keep_watching_page_count > 1">
            <router-link
              :to="
                '/' +
                account_type +
                '/catchup/keep-watching/' +
                getSelectedChildID
              "
              class="btn btn-sm brand_inverse_light font-10"
              >See More</router-link
            >
          </div>
        </div>
      </div>
      <!-- CATCHUP TITLE ROW -->

      <!-- RECOMMEND CARD ROW -->
      <div class="row card-row">
        <div class="card-column" v-for="(item, index) in videos" :key="index">
          <RecommendCard
            theme="dark"
            card_type="video"
            card_title="Video Lesson"
            :video_id="item.token"
            :card_img="item.image || 'VideoCardOne.png'"
            :card_topic="item.new_title"
            :card_meta="item.time_remaining"
            :show_lock="active_subscription"
            :custom_height="true"
            custom_height_value="black keep-watching-card-height"
          ></RecommendCard>
        </div>
      </div>
      <!-- RECOMMEND CARD ROW -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KeepWatchingRow",

  props: {
    videos: Array,
    keep_watching_page_count: Number,
    active_subscription: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    RecommendCard: () =>
      import(
        /* webpackChunkName: "RecommendCard" */ "@/components/classComps/catchup/RecommendCard"
      ),
  },

  computed: {
    ...mapGetters(["getSelectedChildID"]),
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
    };
  },
};
</script>

<style lang="scss">
.keep-watching-row {
  padding-top: 10px;
  margin-top: 30px;
  margin-bottom: 5px;
  border-bottom: none;

  .card-row {
    padding-top: 20px;
    display: flex !important;
    flex-flow: row nowrap !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    overflow: auto;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .card-column {
      width: 184px !important;
      padding: 0 10px;
    }
  }
}
</style>
